<template>
    <div v-show="false"></div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    data() {
        return {
            chatScript: this.$config.front.chatScript,
            chatId: this.$config.front.chatId,
            useDefaultLauncher: true,
        };
    },
    head() {
        return {
            script: [
                {
                    vmid: 'front-sdk',
                    src: this.chatScript,
                    id: 'front-sdk',
                    type: 'text/javascript',
                    body: true,
                    skip: this.frontScriptLoaded,
                    callback: () => this.setScriptLoaded(),
                },
                {
                    vmid: 'front-init',
                    id: 'front-init',
                    type: 'text/javascript',
                    body: true,
                    skip: !this.frontScriptLoaded,
                    innerHTML: `
                        window.FrontChat('init', {
                            chatId: ${JSON.stringify(this.chatId)},
                            useDefaultLauncher: ${JSON.stringify(this.useDefaultLauncher)},
                            onInitCompleted: window.__onFrontInit
                        });
                    `,
                    __dangerouslyDisableSanitizersByTagID: {
                        'front-init': ['innerHTML'],
                    },
                },
            ],
        };
    },
    computed: {
        ...mapGetters({
            frontScriptLoaded: 'support/frontScriptLoaded',
        }),
    },
    mounted() {
        window.__onFrontInit = () => {
            this.setFrontInitCompleted();
        };
    },
    methods: {
        ...mapActions({
            setScriptLoaded: 'support/setFrontScriptLoadedTrue',
            setFrontInitCompleted: 'support/setFrontInitCompleted',
        }),
    },
};
</script>
